import angular from 'angular';
import EditMenuComponent from './edit.component';

const editMenuModule = angular.module('tinaba.components.menu.edit', [])

.component('editMenu', EditMenuComponent);

export default editMenuModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/main/edit/edit.js
 **/